export enum FireState {
    IDLE,
    ANGRY,
    BEING_PUT_OUT,
    PUT_OUT
}
